import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=66ba510f&scoped=true"
import script from "./templateDetail.vue?vue&type=script&lang=js"
export * from "./templateDetail.vue?vue&type=script&lang=js"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=66ba510f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba510f",
  null
  
)

export default component.exports